import React from 'react';
import { Link } from 'react-router-dom';
import { FiTruck, FiShoppingBag, FiBriefcase, FiSettings, FiHeart, FiUsers } from 'react-icons/fi';

const WhoWeServePage = () => {
  return (
    <main className="about">
      <section className="sv-hero">
        <div className="container">
          <span className="sv-eyebrow">Who We Serve</span>
          <h1 className="sv-title">Solutions tailored to your operating model</h1>
          <p className="sv-subtitle">From startups to enterprises, we adapt workflows to your volume, product mix, security requirements, and recovery goals—no heavy integrations required.</p>
          <img className="sv-hero-img" src="/service.jpg" alt="Warehouse operations" />
        </div>
      </section>

      <section className="sv-overview">
        <div className="container">
          <h2 className="sv-section-title">Who we partner with</h2>
          <div className="sv-card-grid">
            <Link to="/who-we-serve/3pl-distributors" className="sv-card">
              <div className="sv-card-icon" aria-hidden>
                <FiTruck />
              </div>
              <div className="sv-card-body">
                <h3>3PL & Distributors</h3>
                <p>Reduce dock congestion and move abandoned freight, returns, and excess quickly with compliant routing and transparent reporting.</p>
              </div>
            </Link>
            <Link to="/who-we-serve/retail-ecommerce" className="sv-card">
              <div className="sv-card-icon" aria-hidden>
                <FiShoppingBag />
              </div>
              <div className="sv-card-body">
                <h3>Retail & E‑commerce</h3>
                <p>Speed intake, grading, and resale of customer returns while protecting brand and maximizing recovery value.</p>
              </div>
            </Link>
            <Link to="/who-we-serve/enterprise" className="sv-card">
              <div className="sv-card-icon" aria-hidden>
                <FiBriefcase />
              </div>
              <div className="sv-card-body">
                <h3>Enterprise</h3>
                <p>Decommission IT assets securely with certified data destruction and global compliance documentation.</p>
              </div>
            </Link>
            <Link to="/who-we-serve/manufacturing" className="sv-card">
              <div className="sv-card-icon" aria-hidden>
                <FiSettings />
              </div>
              <div className="sv-card-body">
                <h3>Manufacturing</h3>
                <p>Turn surplus, seasonal, and non-conforming inventory into recovered capital across optimized channels.</p>
              </div>
            </Link>
            <Link to="/who-we-serve/nonprofit" className="sv-card">
              <div className="sv-card-icon" aria-hidden>
                <FiHeart />
              </div>
              <div className="sv-card-body">
                <h3>Nonprofit & Charity</h3>
                <p>Direct donations with impact reporting and documentation while reducing landfill and logistics costs.</p>
              </div>
            </Link>
            <Link to="/who-we-serve/small-business" className="sv-card">
              <div className="sv-card-icon" aria-hidden>
                <FiUsers />
              </div>
              <div className="sv-card-body">
                <h3>Small Business</h3>
                <p>Leverage enterprise-grade reverse logistics without enterprise overhead—start with boxes, scale to truckloads.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="sv-cta">
        <div className="container">
          <div className="sv-cta-inner">
            <h3>Ready to recover more value?</h3>
            <p>Tell us about your inventory profile and objectives—we’ll map the fastest path to recovered capital.</p>
            <div className="sv-cta-actions">
              <a className="signin-btn" href="/contact">Contact Sales</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default WhoWeServePage;


